import { cloudflareCdn } from 'utils/image'

const SvgComponent = () => (
  <img src={cloudflareCdn('/stagvn/assets/svg/stagvn.svg')} height={'60px'} />
)
export default SvgComponent
